<template>
  <div :class="wrapperClass">
    <div
      :class="[
        containerClass,
        {
          'tw-mx-auto tw-w-full tw-max-w-[1232px] tw-px-4 tw-py-6 md:tw-px-6 md:tw-py-16 lg:tw-px-8 xl:tw-px-0': !expand,
        },
      ]"
    >
      <!-- Section Title -->
      <div
        v-if="description || title"
        :class="[
          'tw-flex tw-justify-between tw-items-end tw-gap-4 tw-mb-6',
          headerClass,
        ]"
      >
        <ThemeECommerceDisplayTitle
          :title="title"
          :description="description"
          :title-tag="titleTag"
          :underline="titleUnderline"
          title-class="tw-text-mb-title-1 lg:tw-text-dt-title-1"
          description-class="tw-mt-0 tw-text-mb-body lg:tw-text-dt-body tw-text-dark-gray"
        />

        <!-- Desktop See More Link -->
        <div
          v-if="seeMorePath && titleSeeMore"
          class="tw-hidden md:tw-block tw-self-end"
        >
          <NuxtLink
            :to="seeMorePath"
            :title="$t('global.seeAll', { title })"
            class="tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-light-gray-2 tw-pb-1 tw-text-[16px] tw-leading-[24px] tw-font-normal tw-text-primary md:tw-text-dt-button hover:tw-border-primary"
            @click="
              eventHomeSeeMore(
                categoryEventName,
                $t('global.seeAll', { title: titleSeeMore }),
              )
            "
          >
            <span>
              {{ $t("global.seeAll", { title: titleSeeMore }) }}
            </span>
            <QIcon name="arrow_forward" />
          </NuxtLink>
        </div>
      </div>

      <!-- Content -->
      <slot :class="contentClass" />

      <!-- Mobile See More Link -->
      <div
        v-if="seeMorePath && titleSeeMore"
        class="tw-flex tw-justify-center tw-mt-6 md:tw-hidden"
      >
        <NuxtLink
          :to="seeMorePath"
          :title="$t('global.seeAll', { title })"
          class="tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-light-gray-2 tw-pb-1 tw-text-[16px] tw-leading-[24px] tw-font-normal tw-text-primary md:tw-text-dt-button hover:tw-border-primary"
          @click="
            eventHomeSeeMore(
              $t('global.seeAll', { title: titleSeeMore }),
              eventName,
            )
          "
        >
          <span>
            {{ $t("global.seeAll", { title: titleSeeMore }) }}
          </span>
          <QIcon name="arrow_forward" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    titleTag?: string;
    description?: string;
    title?: string;
    seeMorePath?: string;
    menuCode?: string;
    categoryEventName: string;
    eventName: string;
    titleUnderline?: boolean;
    wrapperClass?: string;
    containerClass?: string;
    headerClass?: string;
    contentClass?: string;
    expand?: boolean;
  }>(),
  {
    titleTag: "h2",
    description: "",
    title: "",
    seeMorePath: "",
    menuCode: "",
    categoryEventName: "",
    eventName: "",
    titleUnderline: false,
    wrapperClass: "",
    containerClass: "",
    headerClass: "",
    contentClass: "",
    expand: false,
  },
);

const menuStore = useMenuStore();

const titleSeeMore = computed(() => {
  if (props.seeMorePath && props.menuCode) {
    return menuStore.list.find((l) => l.code === props.menuCode)?.title;
  }
  return "";
});

const { analyticEvent, fbPixelEvent } = useAnalytic();
const eventHomeSeeMore = (seeMoreTitle: string, eventName: string) => {
  // Add your event tracking logic here
  analyticEvent({
    ga4ActionName: eventName,
    ga4Label: seeMoreTitle,
  });
  fbPixelEvent({
    fbCategory: "trackCustom",
    fbEvent: "Promotion - Home",
    fbValue: { label: seeMoreTitle },
  });
};
</script>

<style lang="scss" scoped>
.ecommerce-section {
  padding: 64px 0px;
  .seemore-link {
    font-size: 16px !important;
  }
  .section-header {
    display: flex;
    flex-direction: column;
    .section-description {
    }
    .seemore-link {
      color: var(--wft-primary-color);
    }
    .seemore-link:hover {
      opacity: 0.8;
    }
  }
}
</style>
